export default "__VITE_ASSET__2G_z9wom__"